<template>
  <div class="flex flex-col gap-2">
    <draggable
      tag="ul"
      class="draggable-list flex flex-wrap gap-y-3"
      ghost-class="moving-card"
      filter=".ignore"
      :list="questions"
      :animation="200"
    >
      <div
        class="relative shadow bg-white w-full rounded-lg border border-grey-light border-solid p-2 flex"
        style="min-height: 5rem"
        v-for="(question, index) in questions"
        :key="question.id"
      >
        <feather-icon icon="MenuIcon" class="mr-2 cursor-move" svgClasses="h-4 w-4" />
        <!-- <vs-select v-model="question.type">
          <vs-select-item v-for="item in ['comment', 'integerRating']" :key="item" :value="item" :text="item" />
        </vs-select> -->
        <vs-textarea v-model="question.text" class="flex-grow -mb-1" :rows="2" />
        <div class="flex items-center ml-1">
          <vs-button
            icon="icon-trash"
            icon-pack="feather"
            @click.stop="confirmRemove(question)"
            type="flat"
            color="primary"
            class="w-3 h-3"
          />
        </div>
        <div class="absolute left-0 top-0 ml-3 mt-2 font-bold font-mono text-center flex justify-between">
          <div>
            {{ index + 1 }}
          </div>
        </div>
        <div class="absolute left-0 bottom-0 ml-2 mb-2 font-bold font-mono text-center flex justify-between">
          <feather-icon icon="MessageSquareIcon" svgClasses="h-4 w-4" />
        </div>
      </div>
    </draggable>
    <vs-button class="mx-4 mt-2" @click="addQuestion">Add question</vs-button>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { v4 as uuidv4 } from "uuid";

export default {
  components: {
    draggable
  },
  props: {
    questions: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    addQuestion() {
      this.questions.push({
        id: uuidv4(),
        text: "",
        type: "comment"
      });
    },
    confirmRemove(question) {
      this.$vs.dialog({
        title: "Remove question",
        text: "Are you sure you want to remove this question?",
        color: "danger",
        accept: () => {
          this.questions.splice(this.questions.indexOf(question), 1);
        }
      });
    }
  }
};
</script>